import React, { Component } from 'react'
import { Row, Col, Input, Modal, DatePicker } from 'antd'
import $ from 'jquery'

const { TextArea } = Input;


export default class NewAsset extends Component {

    constructor( props ){
        super( props );

        this.state = {
            asset_type: '',
            asset_model: '',
            asset_serial: '',
            dv_asset_serial: '',
            notes: '',
            visible: false
        }

        this.handleCancel = this.handleCancel.bind( this ); 
        this.handleOk = this.handleOk.bind( this );

    }

    componentWillReceiveProps( nextProps ){
        if( nextProps ){
            this.setState({ visible: nextProps.onModel })
        }
    }

    handleCancel(){
        this.props.onCancel( false );
    }

    handleOk(){

        let temp_data = {
            asset_type: this.state.asset_type,
            asset_model: this.state.asset_model,
            asset_serial: this.state.asset_serial,
            dv_asset_serial: this.state.dv_asset_serial,
            notes: this.state.notes,
        }

        if( temp_data['asset_type'] && temp_data['asset_model'] && temp_data['asset_serial'] ){
            this.props.onSubmit( temp_data );
            this.props.onCancel( false );

            this.setState({
                asset_type: '', asset_model: '', asset_serial: '', dv_asset_serial: '', notes: '',
            });

        }

    }

    render() {
        return (

            <Modal
                title="Add New Asset"
                maskClosable={ false }
                visible={this.state.visible}
                onOk={this.handleOk}
                onCancel={this.handleCancel}
                >
                <Row className="mrg_b_10" gutter={16}>
                    <Col span={ 12 }>
                        <label>Device Type</label>
                        <Input onChange={ (e)=> this.setState({ asset_type: e.target.value }) } />
                    </Col>
                
                    <Col span={ 12 }>
                        <label>Device Model</label>
                        <Input onChange={ (e)=> this.setState({ asset_model: e.target.value }) } />
                    </Col>
                </Row>
                <Row className="mrg_b_10" gutter={16}>
                    <Col span={ 12 }>
                        <label>Device Serial Number</label>
                        <Input onChange={ (e)=> this.setState({ asset_serial: e.target.value }) } />
                    </Col>
                
                    <Col span={ 12 }>
                        <label>DV Serial Number</label>
                        <Input onChange={ (e)=> this.setState({ dv_asset_serial: e.target.value }) } />
                    </Col>
                </Row>

                <Row className="mrg_b_10">
                    <Col span={ 24 }>
                        <label>Notes</label>
                        <TextArea onChange={ (e)=> this.setState({ notes: e.target.value }) } />
                    </Col>
                </Row>
                
                <Row className="mrg_b_10">
                    <Col span={24}>
                        
                    </Col>
                </Row>
            </Modal>

        )
    }



}


// WEBPACK FOOTER //
// ./src/pages/assets/childs/new.assets.js